export const PopupEnum = {
    Close: 0,
    Registration: 1,
    RecoverPassword: 2,
    Login: 3,
    ForgotPassword: 4,
    ChangePassword: 5,
    ChangePasswordSuccess: 6,
    Email: 7,
    MobileNumber: 8,
    VerifySuccess: 9,
    RecoverPasswordSuccess: 10,
    RegistartionFormSuccess: 11,
    MyProfile: 12,
    Cashier: 13,
    Offers: 14,
    Messages: 15,
    GameHistory: 16,
    Tournaments: 17,
    ReferrerReport: 18,
    Promotions: 19,
    ForgotUsername: 20,
    ForgotUsernameSuccess: 21,
    MobileProfileMenu: 100,
    Join: 23,
    Ad: 24,
    Identification: 25,
    RequestCallback: 26,
    AccountMenu: 27,
    OneClickRegistartionFormSuccess: 28,
    TwoFactorAuth: 29,
    ActiveSessions: 30,
    ActivityLog: 31,
    RequestCashBack: 32,
    SportBetVerification:33,
    CupisOTP: 34,
	TrustedBrowsers: 35,
    Wallet: 36,
    Passkey: 37,
    AccountSecurity: 38
}

Object.freeze(PopupEnum);

export const popupHashes = {
    registration: { val: "popup/registration", auth: false },
    login: { val: "popup/login", auth: false },
    forgotpassword: { val: "popup/forgotpassword", auth: false },
    forgotusername: { val: "popup/forgotusername", auth: false },
    changepassword: { val: "popup/changepassword", auth: true },
    myprofile: { val: "popup/myprofile", auth: true },
    accountmenu: { val: "popup/accountmenu", auth: true },
    documents: { val: "popup/documents", auth: true },
    identification: { val: "popup/identification", auth: true },
    activesessions: { val: "popup/activesessions", auth: true },
    trustedbrowsers: { val: "popup/trustedbrowsersreport", auth: true },
    accountsecurity: { val: "popup/accountsecurity", auth: true },
    activitylog: { val: "popup/activitylog", auth: true },
    passkey: { val: "popup/passkey", auth: true },
    twoFactorAuth: { val: "popup/twofactorauth", auth: true },
    preferences: { val: "popup/preferences", auth: true },
    responsibleGaming: { val: "popup/responsiblegaming", auth: true },
    accountClosure: { val: "popup/accountclosure", auth: true },
    depositLimit: { val: "popup/depositlimit", auth: true },
    timeOut: { val: "popup/timeout", auth: true },
    nsep: { val: "popup/nsep", auth: true },
    betLimit: { val: "popup/betlimit", auth: true },
    selfExclusion: { val: "popup/selfexclusion", auth: true },
    cashier: { val: "popup/cashier", auth: true },
    deposithistory: { val: "popup/deposithistory", auth: true },
    withdrawal: { val: "popup/withdrawal", auth: true },
    transaction: { val: "popup/transaction", auth: true },
    cashiersettings: { val: "popup/cashiersettings", auth: true },
    withdrawalhistory: { val: "popup/withdrawalhistory", auth: true },
    offers: { val: "popup/offers", auth: true },
    promocodes: { val: "popup/promocodes", auth: true },
    freespins: { val: "popup/freespins", auth: true },
    bonushistory: { val: "popup/bonushistory", auth: true },
    prizeshistory: { val: "popup/prizeshistory", auth: true },
    casinobonuses: { val: "popup/casinobonuses", auth: true },
    bonusesV2: { val: "popup/mybonuses", auth: true },
    newBonusesV2: { val: "popup/newbonuses", auth: true },
    realmoneybonuses: { val: "popup/realmoneybonuses", auth: true },
    sportbonuses: { val: "popup/sportbonuses", auth: true },
    sporttournaments: { val: "popup/sporttournaments", auth: true },
    tournamenthistory: { val: "popup/tournamenthistory", auth: true },
    messages: { val: "popup/messages", auth: true },
    gamehistory: { val: "popup/gamehistory", auth: true },
    tournaments: { val: "popup/tournaments", auth: true },
    referrerreport: { val: "popup/referrerreport", auth: true },
    bonuses: { val: "popup/bonuses", auth: true },
    mobilenumber: { val: "popup/mobilenumber", auth: true },
    email: { val: "popup/email", auth: true },
    promotions: { val: "popup/promotions", auth: false },
    custom: { val: "popup/ad", auth: false },
    join: { val: "popup/join", auth: false },
    realityChecks: { val: "popup/realitycheck", auth: true },
    requestcashback: { val: "popup/requestcashback", auth: true },
    requestcallback: { val: "popup/requestcallback", auth: true },
    accessLimit: { val: "popup/accesslimit", auth: true },
    timeLimit: { val: "popup/timelimit", auth: true },
    cupisotp: { val: "popup/cupisotp", auth: true },
    lossLimit: { val: "popup/losslimit", auth: true },
    inviteFriend: { val: "popup/invitefriend", auth: true },
    statusTracking: { val: "popup/statustracking", auth: true },
    wallet: { val: "popup/wallet", auth: true },
    campaign: { val: "popup/campaign", auth: true },
}

export const myProfileFormStates = {
    changePasswordForm: 'changePasswordForm',
    changePasswordFormSuccess: 'changePasswordFormSuccess',
    mobileNumber: 'mobileNumber',
    email: 'email',
    emailSuccess: 'emailSuccess',
    mobileNumberSuccess: 'mobileNumberSuccess'
}

export const myProfileFormStatesTranslations = {
    changePasswordForm: { name: 'passwordChange', section: 'changePassword' },
    changePasswordFormSuccess: { name: 'passwordChange', section: 'changePassword' },
    mobileNumber: { name: 'mobileNumberVerificationForm', section: 'account' },
    email: { name: 'emailVerificationForm', section: 'account' },
    emailSuccess: { name: 'emailVerificationForm', section: 'account' },
    mobileNumberSuccess: { name: 'mobileNumberVerificationForm', section: 'account' }
}

export const verificationEnum = {
    DocumentNumber: 'Document',
    MobileNumber: 'MobileNumber',
    Email: 'Email'
}
export const PopupColorModeEnum = {
    Light: 1,
    Dark: 2,
    Night: 3
}


export const UiSettingModeEnum = {
    1: 'popUpColorModeDark',
    2: 'popUpColorModeLight'
}

export const PopupDisplaySettingsEnum = {
    Page: 0,
    Popup: 1,
}
export default PopupEnum;